(function () {
    'use strict';

     function ReserveServiceItemV2Controller($uibModal, $scope, $state, $stateParams, $timeout, PriceInfoCustom, PriceInfoSearch, ParseLinks, AlertService, paginationConstants, translate, translatePartialLoader, ServiceOptionItem, ServiceOptionItemCustom, PriceInfoDtailCustom, OrderBagServiceItem, ServiceItemCustom, ServiceTimeSessionCustom, SettingInfoCustom, ServiceTimeSession, dateUtil, ScheduleInfoCustom, TimingInfo, OrderBagCustom, Servant, DateUtils, OrderBagServiceItemCustom,ServantCustom,Principal,ActivityTypeInfoCustom,CompanyCustom) {

        var firstHourInDay = 8;
        var $ctrl = this;
        var pagingParams = {};
        $ctrl.loadPage = loadPage;
        $ctrl.formState = 'orderbagitem';
        // $ctrl.initMode ='DEFAULT';
        $ctrl.options = null;
        $ctrl.getPriceInfoDtail = getPriceInfoDtail;
        $ctrl.priceInfoDtails = null;
        $ctrl.addOrderBagDtails = addOrderBagDtails;
        $ctrl.computeTotalPrice = computeTotalPrice;
        $ctrl.isSaving = false;
        //$ctrl.findFormState = findFormState;
        $ctrl.prev = prev;

        $ctrl.serviceItem_changed = serviceItem_changed;
        $ctrl.openPersonInfoModal = openPersonInfoModal;
        $ctrl.serviceItems = null;
        $ctrl.qtyChanged = qtyChanged;
        $ctrl.availableDates_changed = availableDates_changed;
        $ctrl.availableTimes_changed = availableTimes_changed;
        $ctrl.servant_changed = servant_changed;
        $ctrl.availableDynamicDates_changed = availableDynamicDates_changed;
        $ctrl.availableDynamicFromTime_changed = availableDynamicFromTime_changed;
        $ctrl.availableDynamicToTime_changed = availableDynamicToTime_changed;

        $ctrl.updateAvailableDates = updateAvailableDates;
        $ctrl.updateAvailableFromTime = updateAvailableFromTime;
        $ctrl.updateAvailableToTime = updateAvailableToTime;
        $ctrl.updateServantList = updateServantList;
        $ctrl.updateServiceList = updateServiceList;

        $ctrl.servantList = [];
        $ctrl.selectedServiceTimeSession = {};
        $ctrl.selectedDynamicDate = null;
        $ctrl.selectedDynamicTime = null;
        $ctrl.allAvailableDynamicTimes = null;
        $ctrl.selectedServant = null;
        $ctrl.timeUnitQty = 1;
        $ctrl.selectedToTime = null;
        $ctrl.showPrices = showPrices;
        if (!$ctrl.editMode)
            $ctrl.editMode = 'NONE'; // 'EDIT' , 'NONE'

        $ctrl.scheduleType = 'PRIMARY';
        $ctrl.floatingTimeType = null;
        $ctrl.availableQty = [];
        $ctrl.maxAvailableQty = 0;
        $ctrl.showCountBox = true;
        $ctrl.selectedService = null;
        $ctrl.selectedServiceDuration = null;


        $ctrl.availableTimeUnitQty = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
        $ctrl.timeUnitQty_Changed = timeUnitQty_Changed;


        // $ctrl.settingInfo = SettingInfoCustom.getSettingInfoByCurrentCompany().query();
        //test
        //--------------------
        $ctrl.simulateQuery = false;
        $ctrl.isDisabled = false;
        $ctrl.servicesNames = [];
        $ctrl.querySearch = querySearch;
        //--------------------
        $ctrl.fromDateToLoad = new Date();
        $ctrl.toDateToLoad = DateUtils.addDays(new Date(), 30);
        $ctrl.isDatesLoading = false;
        $ctrl.loadMoreAvailableDates = loadMoreAvailableDates;
        //$ctrl.showUnPlannedTime = false;
        $ctrl.showUnPlannedTimeChange = showUnPlannedTimeChange;

        $ctrl.isCapacityAvailable = true;

        $ctrl.checkCapacityInProgress = false;

        $ctrl.canSelectOtherServant = false;
        $ctrl.canSelectOtherServant = !Principal.hasAnyAuthority(["ROLE_SERVANT_LOGIN"])
        $ctrl.activityTypeInfo = {};
        //-------------------------------
        loadPage();

        function loadPage(page) {
            translatePartialLoader.addPart('orderBagServiceItemDtail');
            translatePartialLoader.addPart('orderBagServiceItem');
            translatePartialLoader.addPart('orderBagItemOption');
            translatePartialLoader.addPart('global');
            translatePartialLoader.addPart('participantPerson');
            translatePartialLoader.addPart('servant');
            translatePartialLoader = translate.refresh();

            if ($ctrl.showUnPlannedTime == null)
                $ctrl.showUnPlannedTime = false;


            if ($ctrl.showOptionItems == null)
                $ctrl.showOptionItems = true;

            initServiceItem();
            // updateServiceList(setDefaultValues);


            if (!$ctrl.defaultServantId)
                loadAllServiceItems(setDefaultValues);
            else {
                if (!$ctrl.canSelectOtherServant) {
                    loadServiceItemsByServantId(setDefaultValues);
                    loadDefaultServant();
                } else {
                    loadAllServiceItems(setDefaultValues);
                    loadAllServants();
                }

            }

            if ($ctrl.showUnPlannedTime) {
                $ctrl.checkCapacity = false;
                if ($ctrl.defaultStartDate)
                    makeDateList();
            }

            getActivityTypeInfo();

        }

        function getActivityTypeInfo() {
            CompanyCustom.getCurrentCompany().query(function (result) {
                ActivityTypeInfoCustom.getActivityTypeInfoByType(result.activityType).query(function (activity) {
                    $ctrl.activityTypeInfo = activity;
                    if (activity && activity.servantType == "RESOURCE") {
                        $ctrl.isWorkSpace = true;
                    }

                })

            });
        }

        function loadAllServants() {
            //if servant_login just current servant must selected
            ServantCustom.findServantsByCompany().query(function (result) {
                $ctrl.servantList = result;
                setDefaultServant();
            });
        }


        function loadDefaultServant() {
            if (!$ctrl.defaultServantId)
                return;
            $ctrl.servantList = [];
            Servant.get({id: $ctrl.defaultServantId}).$promise.then(function (result) {
                $ctrl.servantList.push(result);
                $ctrl.orderBagServiceItem.servant = result;
            });

        }

        function querySearch(query) {

            var temp = [];


            angular.forEach($ctrl.serviceItems, function (item) {
                if (item.itemTitle.indexOf(query) > -1) {
                    temp.push(item);
                } else if (query == null) {
                    temp = $ctrl.serviceItems;
                }
            })

            return temp;

        }

        function loadAllServiceItems(then) {


            ServiceItemCustom.getActiveServiceItemsByCurrentCompany().query(function (items) {
                $ctrl.serviceItems = items;
                if (then) {
                    then();
                }
            });
        }

        function loadServiceItemsByServantId(then) {

            if ($ctrl.defaultServantId) {
                if (!$ctrl.canSelectOtherServant) {
                    ServiceItemCustom.getServiceItemsByServantId($ctrl.defaultServantId).query(function (items) {
                        $ctrl.serviceItems = items;
                        if (then)
                            then();
                    });
                }
            }
        }

        function serviceItem_changed(item) {

            $ctrl.selectedDate = null;
            $ctrl.selectedServiceTimeSession = {};

            if (item) {
                $ctrl.orderBagServiceItem.serviceItemId = item.id;
                if (item.duration)
                    $ctrl.selectedServiceDuration = item.duration;

                updateServantList();
            } else {
                $ctrl.orderBagServiceItem.serviceItemId = null;
                $ctrl.servantList = [];
            }
            $timeout(function(){
                orderBagItem_Changed();
                $ctrl.onServiceChanged();
            }, 1000)
            //


        }

        function setServant(servantid) {
            $ctrl.orderBagServiceItem.servant = null;

            //in edit mode always must select default servant
            if($ctrl.defaultServantId && $ctrl.editMode == 'EDIT')
            {
                servantid = $ctrl.defaultServantId;
            }
            if (servantid) {
                $ctrl.orderBagServiceItem.servant = {};
                $ctrl.orderBagServiceItem.servant.id = servantid;

            }

        }

        function getServantId() {

            if ($ctrl.orderBagServiceItem.servant)
                return $ctrl.orderBagServiceItem.servant.id;
            if ($ctrl.selectedServant)
                return $ctrl.selectedServant.id;

            return null;
        }

        function updateServantList(then) {
            //for now if 'REPLACE_TIME' return

            // if ($ctrl.editMode == 'EDIT')
            //     return;

            resetLoadDatesDefault();

            // if ($ctrl.showUnPlannedTime == true) {
            //     updateServantListWithDefault();
            //     setDefaultToTime();
            //     availableDynamicToTime_changed();
            //     return;
            // }


            setServant();
            $ctrl.servantList = [];
            if ($ctrl.orderBagServiceItem.serviceItemId) {
                ServiceItemCustom.getServiceServants($ctrl.orderBagServiceItem.serviceItemId).query(function (servants) {
                        $ctrl.servantList = servants;

                        if ($ctrl.defaultServantId && !$ctrl.canSelectOtherServant) {
                            $ctrl.servantList = [];
                            angular.forEach(servants, function (srv) {
                                if (srv.id == $ctrl.defaultServantId)
                                    $ctrl.servantList.push(srv);
                            })
                        }
                        if ($ctrl.servantList && $ctrl.servantList.length > 1) {
                            ServiceItemCustom.getAutoSelectServant($ctrl.orderBagServiceItem.serviceItemId).query(function (selecedServant) {

                                    if (selecedServant && selecedServant.id) {
                                        angular.forEach($ctrl.servantList, function (s) {
                                            if (s.id == selecedServant.id)
                                                setServant(selecedServant.id);
                                        });
                                    } else {
                                        if ($ctrl.servantList[0])
                                            setServant($ctrl.servantList[0].id);

                                        if (then)
                                            then();
                                    }
                                    if (then)
                                        then();

                                    $ctrl.updateAvailableDates(then);
                                },
                                function () {
                                    if ($ctrl.servantList[0])
                                        setServant($ctrl.servantList[0].id);

                                    if (then)
                                        then();
                                    $ctrl.updateAvailableDates(then);
                                })

                        } else {
                            if ($ctrl.servantList[0])
                                setServant($ctrl.servantList[0].id);

                            if (then)
                                then();
                            $ctrl.updateAvailableDates(then);
                        }
                    }
                    , function () {
                        if (then)
                            then();
                        $ctrl.updateAvailableDates(then);

                    });
            }
        }

        function updateServantListWithDefault() {
            $ctrl.servantList = [];

            if ($ctrl.defaultServantId) {
                loadDefaultServant();
                setServant($ctrl.defaultServantId);
            } else {
                if ($ctrl.orderBagServiceItem.serviceItemId) {
                    ServiceItemCustom.getServiceServants($ctrl.orderBagServiceItem.serviceItemId).query(function (servants) {
                        $ctrl.servantList = servants;
                    });
                }
            }
        }

        function updateServiceList(then) {

            $ctrl.serviceItems = ServiceItemCustom.getActiveServiceItemsByCurrentCompany().query(onSuccess);

            function onSuccess() {
                if (then) {
                    then();
                }
                $ctrl.updateServantList(then);

            }
        }

        function setDefaultValues() {

            initDefaultSelectedItems();
            setDefaultServiceItem();
            setDefaultDateAndTime();
            setDefaultServant();
        }

        function initDefaultSelectedItems() {

            if ($ctrl.defaultSelectedService != null) {
                $ctrl.selectedService = $ctrl.defaultSelectedService;
                $ctrl.serviceItem_changed($ctrl.selectedService)
            }
            if ($ctrl.defaultSelectedServant != null) {
                $ctrl.selectedServant = $ctrl.defaultSelectedServant;
                setServant($ctrl.defaultSelectedServant.id)
                // $ctrl.orderBagServiceItem.servant = $ctrl.defaultSelectedServant;
                $ctrl.servant_changed();
            }
            if ($ctrl.defaultSelectedServantId != null) {
                setServantSelected($ctrl.defaultSelectedServantId);
                $ctrl.servant_changed();
            }

        }

        function setServantSelected(servantId) {

            var selectedServant = null;
            angular.forEach($ctrl.servantList, function (servant) {
                if (servant.id == servantId) {
                    selectedServant = servant;
                }
            });
            $ctrl.selectedServant = selectedServant;
            setServant(servantId);
        }

        function initServiceItem() {
            // if ($ctrl.editMode == 'EDIT')
            //     return;


            if (!$ctrl.orderBagServiceItem)
                $ctrl.orderBagServiceItem = {};
            $ctrl.orderBagServiceItem.servant = {};
            if (!$ctrl.orderBagServiceItem.index)
                $ctrl.orderBagServiceItem.index = 0;
        }

        function setDefaultServiceItem() {

            if ($ctrl.defaultServiceItemId != null && $ctrl.defaultServiceItemId != undefined) {
                $ctrl.orderBagServiceItem.serviceItemId = Number($ctrl.defaultServiceItemId);
                //$ctrl.serviceItem_changed();
                //setDefaultTimeSession();
                //setDefaultDateAndTime();
                //setDefaultServant();
                // loadAvailableDates();
            }
        }

        function setDefaultServant() {
            if ($ctrl.defaultServantId)
                setServant($ctrl.defaultServantId);

        }

        function setDefaultDateAndTime() {

            if (!$ctrl.showUnPlannedTime)
                return;

            if ($ctrl.defaultStartDate != null && $ctrl.defaultStartDate != undefined) {
                $ctrl.selectedDynamicDate = dateUtil.convertToISOString(new Date($ctrl.defaultStartDate));

            }
            if ($ctrl.defaultEndDate != null && $ctrl.defaultEndDate != "" && $ctrl.defaultEndDate != undefined) {

                $ctrl.selectedToTime = new Date($ctrl.defaultEndDate).toISOString();
                $ctrl.selectedDynamicTime = new Date($ctrl.defaultStartDate).toISOString();
            }
        }

        function getPriceInfoDtail(then) {
            if ($ctrl.orderBagServiceItem.serviceItemId == undefined || $ctrl.orderBagServiceItem.serviceItemId == null || $ctrl.orderBagServiceItem.serviceTimeSession == undefined || $ctrl.orderBagServiceItem.serviceTimeSession == null) {
                // error
                // have to evaluate
                return;
            }
            if ($ctrl.orderBagServiceItem != null && $ctrl.orderBagServiceItem != undefined && $ctrl.orderBagServiceItem.status != null && $ctrl.orderBagServiceItem.status == 1) {
                //do nothing
                // in view mode and not editable
            } else {
                var servantId = null;
                if($ctrl.orderBagServiceItem.servant){
                     if ($ctrl.orderBagServiceItem.servant.id)
                            servantId = $ctrl.orderBagServiceItem.servant.id;
                        PriceInfoDtailCustom.getPriceInfoDtailByServiceItemFromDate($ctrl.orderBagServiceItem.serviceItemId, servantId, $ctrl.orderBagServiceItem.serviceTimeSession.startTime).query(function (result) {

                            $ctrl.priceInfoDtails = result;
                            addOrderBagDtails();
                            // $ctrl.serviceItem_changed();
                            //reloadPrices();
                            changeControlsData();
                        });
                }

            }

             if (then)
                 then();
        }

        function addOrderBagDtails() {

            clearOrderBagDetails();

            if ($ctrl.orderBagServiceItem == null || $ctrl.orderBagServiceItem == undefined) {
                $ctrl.orderBagServiceItem = {};
            }
            if ($ctrl.orderBagServiceItem.orderBagServiceItemDtail == null || $ctrl.orderBagServiceItem.orderBagServiceItemDtail == undefined) {
                $ctrl.orderBagServiceItem.orderBagServiceItemDtail = [];
            }

            var x;
            for (var i = 0, len = $ctrl.priceInfoDtails.length; i < len; i++) {

                x = $ctrl.priceInfoDtails[i];
                if (x == null)
                    continue;

                //if priceInfoDetailID set in ReserveServiceItemDtail must Update Quantity
                //if (UpdateExistReserveServiceItemDtail(x, orderbagOptions))
                if (false) {
                    //do nothing
                } else {
                    var defaultQty = 0;
                    if (i == 0) defaultQty = 1;
                    $ctrl.orderBagServiceItem.orderBagServiceItemDtail.push({
                        gty: defaultQty,
                        price: x.price,
                        discount: x.discount,
                        vat: 0,
                        totalPrice: 0,
                        serviceTimeSession: $ctrl.orderBagServiceItem.serviceTimeSession,
                        //priceInfoDtailId: x.id,
                        priceInfoDtail: x,
                        orderBagItemOptions: null,
                        timeUnitQty: $ctrl.timeUnitQty
                    });
                }
            }

            //   computeTotalPrice();
            setShowCountBox();
        }

        function computeTotalPrice() {
            if ($ctrl.onItemChanged)
                $ctrl.onItemChanged($ctrl.orderBagServiceItem);
        }

        function prev() {
            $ctrl.formState = 'orderbagitem';
            //  reloadPrices();
        }


        function openPersonInfoModal() {
            $uibModal.open({
                templateUrl: 'app/entities/participant-person/order-bag-item-participant-person-dialog.html',
                controller: 'OrderBagParticipantPersonDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    entity: function () {
                        return {
                            id: null
                        };
                    }
                }
            }).result.then(function (result) {
                // addParticipantPerson(result);
            }, function () {
                //nothing
            });


        }


        function clearOrderBagDetails() {
            $ctrl.orderBagServiceItem.orderBagServiceItemDtail = null;
            $ctrl.orderBagServiceItem.orderBagServiceItemDtail = [];
        }

        function changeControlsData() {
            computeTotalPrice();
        }

        function qtyChanged() {
            changeControlsData();
        }

        function servant_changed() {

            resetLoadDatesDefault();
            updateAvailableDates();
            orderBagItem_Changed();

        }

        function availableDates_changed() {
            loadAvailableTimes();
            orderBagItem_Changed();
        }

        function resetLoadDatesDefault() {
            $ctrl.availableDynamicDates = [];
            $ctrl.fromDateToLoad = new Date();
            $ctrl.toDateToLoad = DateUtils.addDays(new Date(), 30);
            $ctrl.loadedMore = false;
        }

        function loadAvailableTimes(then) {

            if ($ctrl.selectedDate == undefined || $ctrl.selectedDate == null)
                return;

            $ctrl.orderBagServiceItem.serviceTimeSession = null;

            var dateTime = new Date($ctrl.selectedDate.toString());
            dateTime.setUTCHours(0, 0, 0);
            ServiceTimeSessionCustom.getAvailableServiceTimeSessionsInOneDate($ctrl.orderBagServiceItem.serviceItemId, dateTime.toISOString()).query(function (list) {
                $ctrl.availableTimes = list;
                if (then)
                    then();

            });

        }

        function availableTimes_changed() {
            // getPriceInfoDtail();
            //changeControlsData();
            orderBagItem_Changed();
        }

        function updateAvailableDates(then) {


            // if ($ctrl.showUnPlannedTime) {
            //     initDefaultUnPLannedDates();
            //     setDefaultToTime();
            //     availableDynamicToTime_changed();
            //     return;
            // }


            if ($ctrl.isDatesLoading)
                return;


            $ctrl.isDatesLoading = true;

            if ($ctrl.showUnPlannedTime)
                ScheduleInfoCustom.getAllDate($ctrl.fromDateToLoad, $ctrl.toDateToLoad).query(function (result) {
                    onLoadDatesSuccess(result, then)
                });
            else
                ScheduleInfoCustom.getDynamicAvailableDatesByServiceIdAndServantId($ctrl.orderBagServiceItem.serviceItemId, getServantId(), $ctrl.fromDateToLoad, $ctrl.toDateToLoad).query(function (result) {
                    onLoadDatesSuccess(result, then)
                });


        }

        function onLoadDatesSuccess(list, then) {

            var filteredList = [];
            var filteredDate = [];
            list.forEach(function (item) {
                if (filteredDate.indexOf(item.spanDate) < 0) {
                    filteredList.push(item);
                    filteredDate.push(item.spanDate);
                }
            });

            filteredList = filteredList.sort(function (a, b) {
                // Turn your strings into dates, and then subtract them
                // to get a value that is either negative, positive, or zero.
                return new Date(a.spanDate) - new Date(b.spanDate);
            });

            if ($ctrl.availableDynamicDates && $ctrl.availableDynamicDates.length > 0) {
                // add new dates to old list
                filteredList.forEach(function (item) {
                    $ctrl.availableDynamicDates.push(item);
                });

            } else {

                $ctrl.availableDynamicDates = filteredList;
                if (filteredList[0]) {
                    $ctrl.selectedDynamicDate = filteredList[0].spanDate;
                    setDefaultDateAndTime();
                }
            }
            $ctrl.isDatesLoading = false;

            if (then)
                then();

            $ctrl.updateAvailableFromTime(then);


        };

        function updateAvailableFromTime(then) {

            $ctrl.selectedDynamicTime = null;
            $ctrl.selectedToTime = null;
            if (!$ctrl.selectedDynamicDate) {
                $ctrl.availableDynamicTimes = [];
                $ctrl.selectedDynamicTime = null;
                $ctrl.updateAvailableToTime(then);
                return;
            }
            var dateTime = new Date($ctrl.selectedDynamicDate.toString());
            dateTime.setUTCHours(0, 0, 0);
            if ($ctrl.showUnPlannedTime)
                makeUnPlannedFromTimeList();
            else
                ScheduleInfoCustom.getDynamicAvailableTimesByServiceIdAndServantIdInOneDate($ctrl.orderBagServiceItem.serviceItemId, getServantId(), dateTime.toISOString()).query(function (result) {
                    onLoadAvailableTimeSuccess(result, then);
                });

        }

        function onLoadAvailableTimeSuccess(result, then) {
            $ctrl.allAvailableDynamicTimes = result;
            $ctrl.availableDynamicTimes = result.filter(function (v) {
                    return (v.capacity > 0)
                }
            );

            $ctrl.availableDynamicTimes = $ctrl.availableDynamicTimes.sort(function (a, b) {
                return new Date(a.startTime) - new Date(b.startTime);
            });

            if ($ctrl.availableDynamicTimes && $ctrl.availableDynamicTimes.length > 0) {

                setDefaultFromTime();
                $ctrl.updateAvailableToTime(then);
                if (then)
                    then();

            }
        }

        function setDefaultFromTime() {
            if ($ctrl.availableDynamicTimes && $ctrl.availableDynamicTimes.length > 0) {
                $ctrl.selectedDynamicTime = $ctrl.availableDynamicTimes[0].startTime;

                if ($ctrl.showUnPlannedTime) {
                    if ($ctrl.defaultStartDate) {
                        var defaultDate = new Date($ctrl.defaultStartDate);
                        var myToday = new Date($ctrl.selectedDynamicDate);
                        myToday = new Date(myToday.getFullYear(), myToday.getMonth(), myToday.getDate(), defaultDate.getHours(), defaultDate.getMinutes(), 0);
                        $ctrl.selectedDynamicTime = myToday.toISOString();
                    } else {
                        var today = new Date($ctrl.selectedDynamicTime.getFullYear(), $ctrl.selectedDynamicTime.getMonth(), $ctrl.selectedDynamicTime.getDate(), firstHourInDay, 0, 0);
                        $ctrl.selectedDynamicTime = today.toISOString();
                    }
                }

                availableDynamicFromTime_changed();

            }
        }

        function makeUnPlannedFromTimeList() {

            // if($ctrl.selectedServiceDuration)
            //     date = new Date(date.getTime() + $ctrl.selectedServiceDuration*60000);

            if (!$ctrl.selectedDynamicDate)
                return;

            $ctrl.fromTimePeriodList = [];
            var startTimes = getSelectableTimes(new Date($ctrl.selectedDynamicDate), true);
            $ctrl.fromTimePeriodList = startTimes;

            onLoadAvailableTimeSuccess($ctrl.fromTimePeriodList);
        }

        function availableDynamicDates_changed() {

            updateAvailableFromTime();
        }

        function availableDynamicFromTime_changed() {
            updateAvailableToTime();
            setDefaultToTime();

            orderBagItem_Changed();

        }

        function updateTimeSessionData() {
            if ($ctrl.selectedDynamicTime != null && $ctrl.selectedToTime != null)
                $ctrl.orderBagServiceItem.serviceTimeSession = createTimeSession($ctrl.selectedDynamicTime, $ctrl.selectedToTime);
        }

        function setMaxAvailableCapacity() {
            var capacity = 1000;
            if ($ctrl.selectedDynamicTime && $ctrl.selectedToTime) {
                if ($ctrl.availableDynamicTimes && $ctrl.availableDynamicTimes.length > 0) {
                    angular.forEach($ctrl.availableDynamicTimes, function (ts) {

                        if (ts.startTime >= $ctrl.selectedDynamicTime && ts.endTime <= $ctrl.selectedToTime) {
                            if (capacity > ts.capacity)
                                capacity = ts.capacity;
                        }

                    })
                } else {
                    capacity = 0;
                }
            }

            $ctrl.availableQty = [0];
            $ctrl.maxAvailableQty = capacity;
            if (capacity > 0) {

                var i = 0;
                while (i < capacity) {
                    i++;
                    $ctrl.availableQty.push(i);
                }
            }

        }

        function updateAvailableToTime(then) {

            if ($ctrl.showUnPlannedTime) {
                if ($ctrl.selectedDynamicDate) {
                    var dateTime = new Date($ctrl.selectedDynamicDate.toString());
                    makeToTimeList(dateTime);
                    return;
                }
            }


            if ($ctrl.selectedDynamicTime == undefined || $ctrl.selectedDynamicTime == null) {
                $ctrl.selectedToTime = null;
                $ctrl.toTimePeriodList = [];
                return;
            }
            $ctrl.selectedToTime = null;

            $ctrl.toTimePeriodList = [];

            var list = $ctrl.allAvailableDynamicTimes.filter(function (v) {
                    return (v.startTime >= $ctrl.selectedDynamicTime)
                }
            );


            var keepGoing = true;
            angular.forEach(list, function (time) {

                if (keepGoing) {
                    if (time.capacity == 0) {
                        keepGoing = false;
                    }
                    if (keepGoing == true)
                        $ctrl.toTimePeriodList.push(time);
                }
            })
            if ($ctrl.toTimePeriodList.length > 0)
                $ctrl.selectedToTime = new Date($ctrl.toTimePeriodList[0].endTime).toISOString();
            if (then)
                then();
            availableDynamicToTime_changed();

        }

        function availableDynamicToTime_changed() {
            //  computeTimeUnitQty();
            updateTimeSessionData();
            setMaxAvailableCapacity();
            // getPriceInfoDtail();
            orderBagItem_Changed();

        }

        function createTimeSession(fromTime, toTime) {
            var newTimeSession = {};

            var fromDate = new Date(fromTime.toString());
            var toDate = new Date(toTime.toString());


            newTimeSession.startTime = fromTime;
            newTimeSession.endTime = toTime;
            newTimeSession.startDate = fromDate;
            newTimeSession.endDate = toDate;
            newTimeSession.capacity = $ctrl.dynamicCapacity;

            return newTimeSession;


        }

        function showPrices() {

            if ($ctrl.scheduleType != 'FLOAT_TIME_SESSIONS') {
                if ($ctrl.orderBagServiceItem.serviceItemId != null && $ctrl.orderBagServiceItem.serviceTimeSession != undefined && $ctrl.orderBagServiceItem.serviceTimeSession.id != undefined)
                    return true;
            }
            if ($ctrl.scheduleType == 'FLOAT_TIME_SESSIONS') {
                if ($ctrl.floatingTimeType == 'HOURLY') {
                    if ($ctrl.orderBagServiceItem.serviceItemId != null && $ctrl.selectedDynamicTime != null && $ctrl.selectedToTime != null)
                        return true;
                }
                if ($ctrl.floatingTimeType == 'MONTHLY') {
                    if ($ctrl.orderBagServiceItem.serviceItemId != null && $ctrl.selectedDynamicMonthlyDate != null && $ctrl.timeUnitQty != null)
                        return true;
                }
            }
        }

        function timeUnitQty_Changed() {

            computeTotalPrice();
            orderBagItem_Changed();
        }

        function setShowCountBox() {

            $ctrl.showCountBox = true;
            if ($ctrl.showUnPlannedTime)
                $ctrl.showCountBox = false;

            if ($ctrl.orderBagServiceItem == null)
                return;

            var selectedServiceItem = findSelectedServiceItem();


            if ($ctrl.orderBagServiceItem.orderBagServiceItemDtail != null && $ctrl.orderBagServiceItem.orderBagServiceItemDtail.length == 1) {
                if (
                    ($ctrl.maxAvailableQty == 1
                        && (selectedServiceItem.servant == null || selectedServiceItem.servant == undefined
                            || (selectedServiceItem.servant != null
                                && (selectedServiceItem.servant.capacity == null || selectedServiceItem.servant.capacity == undefined
                                    || (selectedServiceItem.servant.capacity != null && selectedServiceItem.servant.capacity == 1)))))
                    ||
                    ($ctrl.maxAvailableQty > 1
                        && selectedServiceItem.servant != null && selectedServiceItem.servant != undefined
                        && (selectedServiceItem.servant.capacity == null || selectedServiceItem.servant.capacity == undefined
                            || (selectedServiceItem.servant.capacity != null && selectedServiceItem.servant.capacity == 1)))
                ) {
                    $ctrl.showCountBox = false;
                }
            }


        }

        function findSelectedServiceItem() {

            if ($ctrl.orderBagServiceItem.serviceItemId != null && $ctrl.orderBagServiceItem.serviceItemId != undefined) {
                var temp = $ctrl.serviceItems.filter(function (si) {
                    if (si.id == $ctrl.orderBagServiceItem.serviceItemId)
                        return si;
                })
                if (temp && temp.length > 0)
                    $ctrl.selectedService = temp[0];
            }

            var selectedServiceItem = null;

            if ($ctrl.orderBagServiceItem.serviceItemId != null) {
                selectedServiceItem = $ctrl.serviceItems.filter(function (si) {
                    if (si.id == $ctrl.orderBagServiceItem.serviceItemId)
                        return si;
                })

            }
            return selectedServiceItem;
        }

        function makeDateList() {
            var date = new Date($ctrl.defaultStartDate);
            var dates = [];

            var timeSpan = makeTimeSpanObject(date);
            for (var i = 9; i > 0; i--) {
                var before = {};
                before = new Date(Number(date));
                ;
                before.setDate(date.getDate() - i);

                var beforeTimeSpan = makeTimeSpanObject(before);
                dates.push(beforeTimeSpan);
            }

            dates.push(timeSpan);

            for (var i = 1; i < 10; i++) {
                var after = {};
                after = new Date(Number(date));
                ;
                after.setDate(date.getDate() + i);

                var afterTimeSpan = makeTimeSpanObject(after);
                dates.push(afterTimeSpan);
            }


            $ctrl.availableDynamicDates = dates;
            $ctrl.selectedDynamicDate = timeSpan.spanDate;

            makeTimeList(date);

        }

        function makeTimeSpanObject(date, hour, minute) {
            var timeSpan = {};
            var startTime, endTime = new Date();
            startTime = new Date(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes());
            if (hour != null)
                startTime.setHours(hour);
            if (minute != null)
                startTime.setMinutes(minute);

            timeSpan.spanDate = date.toISOString().split('T')[0];
            timeSpan.startTime = startTime.toISOString();
            timeSpan.endTime = startTime.toISOString();
            if ($ctrl.selectedService && $ctrl.selectedService.capacity)
                timeSpan.capacity = $ctrl.selectedService.capacity;
            else
                timeSpan.capacity = 1;
            timeSpan.comment = "";
            timeSpan.discount = 0;
            timeSpan.edited = false;
            timeSpan.enable = true;
            timeSpan.id = null;
            timeSpan.price = 0;
            timeSpan.reservedCapacity = null;
            timeSpan.servantId = null;
            timeSpan.serviceItemId = null;
            timeSpan.sessionInfoId = null;
            timeSpan.timeSessionType = null;
            timeSpan.timeUnitQty = 0;

            return timeSpan;
        }

        function makeTimeList(date) {

            var selectedFromTime = makeTimeSpanObject(date);
            var startTimes = getSelectableTimes(date, false);
            $ctrl.availableDynamicTimes = startTimes;
            $ctrl.selectedDynamicTime = selectedFromTime.startTime;
            availableDynamicFromTime_changed();

        }

        function makeToTimeList(date) {

            // if($ctrl.selectedServiceDuration)
            //     date = new Date(date.getTime() + $ctrl.selectedServiceDuration*60000);
            $ctrl.toTimePeriodList = [];
            var startTimes = getSelectableTimes(date, true);
            $ctrl.toTimePeriodList = startTimes;
            availableDynamicToTime_changed();
        }

        function getSelectableTimes(date, mustFilter) {
            var startMinute = 0;
            var startHour = 0;
            var stepper = 5;
            var selectableTimes = [];
            for (var h = startHour; h < 24; h++) {
                for (var m = startMinute; m < 60; m = m + stepper) {
                    var time = {};
                    time = makeTimeSpanObject(date, h, m);
                    if (mustFilter) {
                        if (!isInRange(time)) {
                            continue;
                        }

                    }
                    selectableTimes.push(time);
                }

            }
            return selectableTimes;

        }

        function isInRange(timeSpan) {

            var isInRange = true;
            if ($ctrl.selectedDynamicTime) {
                var min = new Date($ctrl.selectedDynamicTime);
                var temp = new Date(timeSpan.startTime);
                if (temp.getHours() > min.getHours()) {

                } else if (temp.getHours() == min.getHours()) {
                    if (temp.getMinutes() <= min.getMinutes()) {
                        isInRange = false;
                    }
                } else {

                    isInRange = false;
                }
            }
            return isInRange;

        }

        function setDefaultToTime() {

            if ($ctrl.selectedServiceDuration) {

                var x = $ctrl.selectedDynamicTime;
                var date = new Date($ctrl.selectedDynamicTime);
                date.setMinutes(date.getMinutes() + $ctrl.selectedServiceDuration);
                $ctrl.selectedToTime = date.toISOString();
                availableDynamicToTime_changed();
                // updateTimeSessionData();
                // getPriceInfoDtail();
            }
        }

        function loadMoreAvailableDates() {
            if (!$ctrl.isDatesLoading) {
                if ($ctrl.availableDynamicDates && $ctrl.availableDynamicDates.length > 0) {
                    $ctrl.fromDateToLoad = new Date($ctrl.availableDynamicDates[$ctrl.availableDynamicDates.length - 1].spanDate);
                    $ctrl.fromDateToLoad = DateUtils.addDays($ctrl.fromDateToLoad, 1);
                    $ctrl.toDateToLoad = DateUtils.addDays($ctrl.toDateToLoad, 30);
                    updateAvailableDates();
                }

            }
        }


        function showUnPlannedTimeChange() {
            if ($ctrl.selectedService)
                serviceItem_changed($ctrl.selectedService);
        }

        // $scope.$watch('$ctrl.orderBagServiceItem',function(){
        //
        // });

        function orderBagItem_Changed() {
            if ($ctrl.orderBagServiceItem
                && $ctrl.orderBagServiceItem.serviceItemId
                && $ctrl.orderBagServiceItem.serviceTimeSession
                && $ctrl.orderBagServiceItem.serviceTimeSession.startTime
                && $ctrl.orderBagServiceItem.serviceTimeSession.endTime
            // && $ctrl.orderBagServiceItem.orderBagServiceItemDtail
            ) {
                if (!$ctrl.checkCapacityInProgress) {
                    $ctrl.checkCapacityInProgress = true;
                    getPriceInfoDtail(checkCapacity);
                }
            }
        }

        function checkCapacity() {

            OrderBagServiceItemCustom.checkCapacityForItem().save($ctrl.orderBagServiceItem, onSuccess, onError);

            function onSuccess(result) {
                if (result.status == 'CAPACITY_FULL')
                    $ctrl.isCapacityAvailable = false;
                else
                    $ctrl.isCapacityAvailable = true;

                $ctrl.checkCapacityInProgress = false;
            }

            function onError() {
                $ctrl.isCapacityAvailable = false;
                $ctrl.checkCapacityInProgress = false;
            }

        }

    }


    var ReserveServiceItemOptions = {
        // template:'tets:{{$ctrl.testStr}}',
        templateUrl: 'app/components/partial-forms/orderbag-service-item/partial-form.reserve-service-item-v2.html',
        controller: ReserveServiceItemV2Controller,
        bindings: {
            onItemChanged:"&",
            onServiceChanged:"&",
            orderBagServiceItem: '=',
            defaultServiceItemId: '=',
            defaultServiceTimeSessionId: '=',
            defaultStartDate: '=',
            defaultEndDate: '=',
            defaultServantId: '=',
            indexOfOrderbag: '=',
            // checkCapacity: '=',
            defaultSelectedService: '=',
            defaultSelectedServant: '=',
            editMode: '=',
            showUnPlannedTime: '=?',
            hasMultipleReserveTime: '=?',
            showOptionItems:'=?'


            //formState:'=',

        }


    };

    angular
        .module('tikonApp')
        .component('pfReserveServiceItemV2', ReserveServiceItemOptions)

    ReserveServiceItemV2Controller.$inject = ['$uibModal', '$scope', '$state', '$stateParams', '$timeout', 'PriceInfoCustom', 'PriceInfoSearch', 'ParseLinks', 'AlertService', 'paginationConstants', '$translate', '$translatePartialLoader', 'ServiceOptionItem', 'ServiceOptionItemCustom', 'PriceInfoDtailCustom', 'OrderBagServiceItem', 'ServiceItemCustom', 'ServiceTimeSessionCustom', 'SettingInfoCustom', 'ServiceTimeSession', 'DateUtils', 'ScheduleInfoCustom', 'TimingInfo', 'OrderBagCustom', 'Servant', 'DateUtils', 'OrderBagServiceItemCustom','ServantCustom','Principal','ActivityTypeInfoCustom','CompanyCustom'];


})();

